import axios from 'axios';
import { getServerUrl } from './serverUrl';

const axiosInstance = axios.create({
  baseURL: getServerUrl(),
});

// Automatically attach token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Handle token errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('adminToken');
      window.location.href = '/Taylor/login'; // force logout
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
